<template>
  <header>
    <Logo />
    <nav>
      <Back :from='from' :pageToGoBackTo='pageToGoBackTo' />
      <h4 :class='{ "cart-empty": cart.itemCount === 0 }'>
        <button class='cart-btn' @click='cart.open()'>
          Cart ({{ cart.itemCount }})
          <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.37212 12.049H15.3227C15.6685 12.049 15.9649 11.7498 15.9649 11.3578C15.9649 10.9555 15.6685 10.6563 15.3227 10.6563H6.50054C6.09551 10.6563 5.82878 10.3366 5.76949 9.88267L4.54447 1.07285C4.44567 0.35074 4.20857 0 3.30955 0H0.65203C0.306257 0 0 0.309479 0 0.691167C0 1.06254 0.306257 1.38233 0.65203 1.38233H3.17124L4.3765 10.058C4.55435 11.2753 5.17674 12.049 6.37212 12.049ZM4.90997 9.16055H15.3919C16.5675 9.16055 17.1899 8.38684 17.3677 7.16958L17.9704 2.96069C17.9901 2.85752 18 2.7234 18 2.65118C18 2.22824 17.6937 1.93939 17.2294 1.93939H4.29746V3.33203H16.4885L15.9846 6.99419C15.9155 7.45842 15.6685 7.77821 15.2437 7.77821H4.90009L4.90997 9.16055ZM6.85619 16C7.57739 16 8.1405 15.412 8.1405 14.6589C8.1405 13.9162 7.57739 13.3179 6.85619 13.3179C6.14491 13.3179 5.57189 13.9162 5.57189 14.6589C5.57189 15.412 6.14491 16 6.85619 16ZM14.1866 16C14.8979 16 15.4709 15.412 15.4709 14.6589C15.4709 13.9162 14.8979 13.3179 14.1866 13.3179C13.4654 13.3179 12.8924 13.9162 12.8924 14.6589C12.8924 15.412 13.4654 16 14.1866 16Z" fill="currentColor"/>
          </svg>
        </button>
      </h4>
      <h4><router-link to='Home'>✕ Close</router-link></h4>
    </nav>
  </header>
</template>

<script setup>
import Logo from './Logo.vue';
import Back from './Back.vue';
import { useCartStore } from './CartStore.js';
const cart = useCartStore();
const props = defineProps(['from', 'pageToGoBackTo']);

/* import { ref, onMounted, onBeforeUnmount } from "vue";
const opacity = ref(0);
const beginning = 300;
const destination = 400;
function listenScroll() {
  if(window.scrollY > destination) {
    opacity.value = 1;
  } else if (beginning < window.scrollY && window.scrollY < destination) {
    opacity.value = (window.scrollY - beginning) / (destination - beginning) ;
  } else {
    opacity.value = 0;
  }
}
onMounted(() => {
    window.addEventListener('scroll', listenScroll)
})
onBeforeUnmount(() => {
    window.removeEventListener('scroll', listenScroll)
})*/
</script>

<style scoped>
@import '../css/breakpoints.css';

  header {
    position: fixed;
    top: 3rem;
    left: 8.5rem;
    right: 8.5rem;
    width: var(--main-width);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    z-index: 999;
    border-radius: 7em;
    padding: 1.5rem 3.5rem 1.95rem;
    border-color: var(--light);
    border-width: 0.1rem;
    border-style: solid;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color:  var(--light);
  }

  @media (--phone) {
    header {
      left: 2rem;
      right: 2rem;
    }
  }

  header:deep(svg) {
    height: 3.25rem;
  }

  header:deep(svg) path {
    fill: var(--light);
    stroke: var(--light);
  }

  header:deep(h4) {
    padding: 1.4rem 0 1.05rem;
    margin: 0;
    margin-left: 1.4rem;
    display: inline-block;
  }

  .cart-empty {
    opacity: 0;
    pointer-events: none;
  }

  .cart-btn {
    background: none;
    border: none;
    color: var(--light);
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    cursor: pointer;
    padding: 0;
    display: inline-flex;
    align-items: baseline;
    gap: 0.6rem;
  }

  .cart-btn svg {
    height: 1em;
    width: auto;
    transform: translateY(0.1em);
  }

  @media print {
    nav {
      display: none !important;
    }
  }
</style>
